import { useSelector } from 'react-redux';
import { State } from 'store/store';
import { Block } from '@chameleoncreator/creator-app';
import getTopics from 'services/apiHelpers/getTopics';

export const useScoringQuizzes = () => {
  const scoringQuizzes = useSelector((state: State) => {
    const topics = getTopics();
    return topics.filter((t: Block) => {
      return t?.props?.asAssessment && t?.props?.scoring;
    });
  });

  return scoringQuizzes;
};
